"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
var _tagModule = _interopRequireDefault(require("./tag.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ArcTag = function ArcTag(_ref) {
  var label = _ref.label,
    linktag = _ref.linktag,
    closable = _ref.closable,
    onClose = _ref.onClose,
    color = _ref.color,
    checkble = _ref.checkble,
    tagData = _ref.tagData,
    selectedtags = _ref.selectedtags,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    statusicon = _ref.statusicon,
    needicon = _ref.needicon;
  var CheckableTag = _lib.Tag.CheckableTag;
  return checkble ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _tagModule["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement("span", null, label), tagData.map(function (tag) {
    return /*#__PURE__*/_react["default"].createElement(CheckableTag, {
      key: tag,
      checked: selectedtags.indexOf(tag) > -1,
      onChange: onChange && onChange,
      onClick: onClick && onClick
    }, tag);
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: _tagModule["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement(_lib.Tag, {
    color: color && color,
    onClose: onClose && onClose,
    closable: closable,
    icon: needicon && /*#__PURE__*/_react["default"].createElement("img", {
      src: statusicon,
      alt: ""
    })
  }, linktag ? /*#__PURE__*/_react["default"].createElement("a", {
    href: "/"
  }, label) : label));
};
var _default = ArcTag;
exports["default"] = _default;